module.exports = __webpack_public_path__ + "img/193.658181e1.jpg";